
import { mapGetters } from "vuex";
import ProfileTags from "@/components/v2/profile-tags.vue";
import ProfileMenuV2 from "~/components/v2/common/profiles/profile-menu-v2.vue";
import { mdiPencil, mdiMonitor, mdiCellphone, mdiAccountEdit } from "@mdi/js";
import UploadBackgroundModal from "~/components/v2/modals/profiles/upload-background-modal.vue";

export default {
  components: {
    ProfileTags,
    ProfileMenuV2,
    UploadBackgroundModal,
  },

  props: {
    profile: {
      type: Object,
      default: () => {},
    },
    showStatuses: {
      type: Boolean,
      default: false,
    },
    inFavorites: {
      type: Boolean,
      default: false,
    },
    isFavoriteProcessing: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      mdiPencil,
      mdiMonitor,
      mdiCellphone,
      mdiAccountEdit,

      coverType: "",
      isEditCoverMenu: false,

      isPcCoverOpen: false,
      isMobileCoverOpen: false,
    };
  },

  computed: {
    ...mapGetters({
      filtersList: "profiles/getFiltersList",
    }),

    nationality() {
      if (this.profile.myDetails) {
        return this.filtersList.nationality[
          +this.profile.myDetails[0].nationality
        ];
      } else if (this.profile.nationality) {
        return this.filtersList.nationality[this.profile.nationality];
      }
      return null;
    },

    city() {
      if (this.profile.location) {
        return this.profile.location[0].baseCity;
      } else if (this.profile.city_id) {
        return this.filtersList.cities.find(
          (city) => city.id === +this.profile.city_id
        )?.title;
      }
      return null;
    },

    age() {
      if (this.profile.myDetails) {
        return this.profile.myDetails[0].age;
      } else if (this.profile.birth_year) {
        return new Date().getFullYear() - +this.profile.birth_year;
      }
      return null;
    },

    hairColor() {
      if (this.profile.myDetails) {
        return this.profile?.myDetails[0]?.hairColor;
      } else if (this.profile.hair_color) {
        return this.filtersList.hair_color[+this.profile.hair_color]?.title;
      }
      return null;
    },

    gender() {
      let gender;
      if (typeof this.profile?.gender === "string") {
        gender = this.profile?.gender?.toLowerCase();
      } else if (typeof this.profile?.gender === "number") {
        gender = this.filtersList.gender[this.profile.gender].toLowerCase();
      } else {
        return null;
      }

      switch (gender) {
        case "male":
          return "male";
        case "transgender":
          return "transsexual";
        default:
          return null;
      }
    },

    // dates() {
    //   const dates = [];
    //   dates.push({
    //     title: this.$t("registered"),
    //     value: this.profile.date_of_creation,
    //   });

    //   // todo: API
    //   if (this.profile.verified_at) {
    //     dates.push({
    //       title: this.$t("verified"),
    //       value: this.profile.date_of_creation,
    //     });
    //   }
    //   dates.push({
    //     title: this.$t("updated"),
    //     value: this.profile.updated_at,
    //   });

    //   // online at - no this date in API
    //   // dates.push({
    //   //   title: "Last seen",
    //   //   value: this.profile.date_of_creation,
    //   // });

    //   return dates;
    // },

    isSlugPage() {
      return this.$route.name === "profile-slug";
    },
  },

  methods: {
    async processFavorite(profile) {
      this.$emit("favoriteClicked", profile);
    },

    openCoverModal(type) {
      this.coverType = type;
      this.$refs.coverModal.open();
    },

    closeCoverModal() {
      this.$refs.coverModal.close();
    },
  },
};
